import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getAssetType() {
    const response = await axiosRequest({
        url: constants.URL.ASSET_TYPE_GET,
        method: METHOD.GET,
        isLoader: false,
    });

    return response == null ? [] : response;
}

export async function createAssetType(data) {
    const response = await axiosRequest({
        url: constants.URL.ASSET_TYPE_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE ASSET TYPE',
        data: data,
    });

    return response;
}

export async function updateAssetType(data) {
    const response = await axiosRequest({
        url: constants.URL.ASSET_TYPE_UPDATE,
        method: METHOD.PUT,
        requestName: 'UPDATE ASSET TYPE',
        data: data,
    });

    return response == true ? false : true;
}

export async function updateAssetTypeImage(file, assetTypeID) {
    const data = new FormData();
    data.append('icon_file', file, file.name);

    const response = await axiosRequest({
        url: constants.URL.ASSET_TYPE_UPDATE_IMAGE,
        method: METHOD.PUT,
        requestName: 'UPDATE IMAGE ASSET TYPE',
        data: data,
        params: {
            asset_type_id: assetTypeID,
        },
        isFile: true,
    });

    return response;
}
